import {Suspense, useEffect} from 'react'
import {Outlet} from 'react-router-dom'
import {I18nProvider} from 'sr/i18n/i18nProvider'
import {LayoutProvider, LayoutSplashScreen} from 'sr/layout/master-layout'
import { SocketProvider } from './pages/component/SocketContext'
import DevelopmentBanner from './DevelopmentBanner'
const App = () => {
  useEffect(() => {
    // Request notification permission and get token
    // requestForToken().then((token) => {
    //   if (token) {

        
    //     // Send the token to your backend
    //   }
    // });

    // Listen for foreground messages
    // onMessageListener().then((payload:any) => {
    //   alert(`New Notification: ${payload.notification.title}`);
    // });
  }, []);

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <SocketProvider> 
      <I18nProvider>
        {process.env.NODE_ENV === 'development' && <DevelopmentBanner />}
        {/* provide the core layout settings, classes, variables, attr and other things */}
        <LayoutProvider>
          {/* <p>Working app.tsx</p> */}
          <Outlet />
        </LayoutProvider>
      </I18nProvider>
      </SocketProvider>
    </Suspense>
  )
}

export {App}
